const CODE_LENGTH = 6;
const TIMER_DURATION = 600;

export const verificationCodeService = {
  createCode: () => {
    return Array(CODE_LENGTH).fill("");
  },

  resetTimer: () => {
    return TIMER_DURATION;
  },

  isCompleted: (code: string[]) => {
    return code.every(Boolean);
  },

  isValidDigit: (value: string) => {
    return /^\d?$/.test(value);
  },

  formatTime: (time: number) => {
    return `${Math.floor(time / 60)}:${String(time % 60).padStart(2, "0")}`;
  },

  getPastedCode: (value: string) => {
    const pasted = value.trim();

    if (!/^\d{6}$/.test(pasted)) {
      return null;
    }

    return pasted.split("");
  },
};
